
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as reactLifecyclesCompat_es from '../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js';

var require$$6 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

export { require$$6 as default };
//# sourceMappingURL=react-lifecycles-compat.es.js.map
